import React, { useEffect, useState } from "react";
import { Row, Skeleton, Col } from "antd";
import { useParams } from "react-router-dom";
import { useGetAdviseeDetails } from "apis/advisee";
import EditableTable from "./components/editableTable/editableTable";

const OwnedPolicies = () => {
  const { id: adviseeId } = useParams();
  const [attachment, setAttachment] = useState([]);

  const {
    isLoading: isAdviseeDetailsLoading,
    data: personalDetails,
  } = useGetAdviseeDetails(adviseeId, {});
  const isConstantsLoading = isAdviseeDetailsLoading;

  useEffect(() => {
    console.log(personalDetails.attachment, 53);
    if (attachment && attachment.length > 0) {
      return;
    }
    setAttachment(personalDetails.attachment);
  }, [personalDetails.attachment]);

  // const renderFileType = filename => {
  //   let formatIndex = String(filename).toLocaleLowerCase().lastIndexOf(".");
  //   let type = String(filename)
  //     .toLowerCase()
  //     .substring(formatIndex + 1, filename.length);
  //   console.log(type);
  //   switch (type) {
  //     case "jpeg":
  //     case "png":
  //     case "jpg":
  //     case "ico":
  //       return String("IMAGE/" + type.toUpperCase());

  //     case "pdf":
  //       return String("APPICATION/" + type.toUpperCase());
  //     default:
  //       return "-";
  //   }
  // };

  // const renderFileTypeImage = filename => {
  //   let formatIndex = String(filename).toLocaleLowerCase().lastIndexOf(".");
  //   let type = String(filename)
  //     .toLowerCase()
  //     .substring(formatIndex + 1, filename.length);
  //   console.log(type);
  //   switch (type) {
  //     case "jpeg":
  //     case "png":
  //     case "jpg":
  //     case "ico":
  //       return require("images/image.png");

  //     case "pdf":
  //       return require("images/pdf.png");
  //     default:
  //       return "-";
  //   }
  // };

  // const renderFileCard =
  //   personalDetails.attachment && personalDetails.attachment.length > 0 ? (
  //     personalDetails.attachment.map(attachment => (
  //       // attachmentList.map(attachment => (
  //       <Col xs={24} md={12} lg={12} xl={6}>
  //         <Row
  //           style={{ width: "100%" }}
  //           align="middle"
  //           style={{
  //             border: "1px solid #e0e0e0",
  //             borderRadius: 8,
  //             padding:
  //               window.innerWidth < ScreenSize.md
  //                 ? "8px 8px 8px 0px"
  //                 : "0px 8px 8px 0px",
  //             margin: 4
  //           }}
  //         >
  //           <Col span={6} style={{ fontSize: 48, paddingRight: 8 }}>
  //             <img src={renderFileTypeImage(attachment.name)} width="100%" />
  //           </Col>
  //           <Col span={18}>
  //             <Row>
  //               <Tooltip title={attachment.name}>
  //                 <Col
  //                   span={24}
  //                   style={{
  //                     fontWeight: "600",
  //                     color: "#000",
  //                     overflow: "hidden",
  //                     textOverflow: "ellipsis",
  //                     whiteSpace: "nowrap"
  //                   }}
  //                 >
  //                   {attachment.name}
  //                 </Col>
  //               </Tooltip>
  //               <Col>
  //                 <div>{renderFileType(attachment.name)}</div>
  //                 <a href={attachment.url} target="_blank">
  //                   <LinkOutlined /> Open Link
  //                 </a>
  //               </Col>
  //             </Row>
  //           </Col>
  //         </Row>
  //       </Col>
  //     ))
  //   ) : (
  //     <Row justify="center" style={{ width: "100%" }}>
  //       <Col>
  //         <Empty description={<span>No Attachment</span>} />
  //       </Col>
  //     </Row>
  //   );

  return (
    <div>
      {isConstantsLoading ? (
        <Skeleton active />
      ) : (
        <Row>
          <Col span={24}>
            <EditableTable data={attachment} expensesTemplate={[]} />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default OwnedPolicies;
